import { Button } from "primereact/button";
import { Card } from 'primereact/card';
import { useNavigate } from "react-router-dom";

interface CustomCardHeaders {
    headerTitle?: string;
    enableBack?: boolean;
    icon?: string;
    navigate?: string;
    [key: string]: any; // To handle other props (like custom styles, additional setup, etc.)
    onClick?: () => void;
}

export default function CustomCard({ headerTitle = "", enableBack = true, icon = "pi pi-home", wifiColor = "--primary-color", navigate, onClick, ...setup }: CustomCardHeaders) {
    const navigateState = useNavigate();

    const triggerNavigation = () => {

        if (onClick) {
            onClick();
        }
        else {
            if (navigate) {
                navigateState(navigate);
            }
        }
    }

    const header = (
        <div className="flex justify-content-between align-items-center px-3 pt-3">
            <div className="flex align-items-center gap-3">
                {enableBack && <Button icon={icon} rounded text raised aria-label="Home" onClick={() => triggerNavigation()} />}
                <div className="flex sm:text-xs md:text-2xl text-4xl font-medium white-space-nowrap overflow-hidden text-overflow-clip ">{headerTitle}</div>
            </div>
            <Button rounded text raised className="flex align-content-center align-items-center gap-2 sm:text-xs md:text-2xl text-4xl">Matiga Peso WiFi <i className="pi pi-wifi p-overlay-badge" style={{ fontSize: '2.5rem', color: wifiColor }}></i></Button>
        </div>
    )

    return (
        <Card
            header={header} {...setup}
            pt={{ body: { className: 'h-full' }, content: { className: 'h-full' } }}>
            {/* pt={{ body: { style: {height: '90%'} }, content: { style: {height: '85%'} } }}> */}
        </Card>
    )
}